 
import React, { useState } from "react";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
 
const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
 
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };
 
  const closeSidebar = () => {
    setSidebarOpen(false);
  };
 
  return (
    <div className="d-flex flex-column min-vh-100">
      {/* NAVBAR */}
      <Navbar toggleSidebar={toggleSidebar} />
 
      <div className="layout-wrapper position-relative">
        {sidebarOpen && (
          <div className="sidebar-overlay" onClick={closeSidebar}></div>
        )}
 
        <Sidebar isOpen={sidebarOpen} closeSidebar={closeSidebar} />
 
        <div className="content-area d-flex flex-column bg-light">
          <main className="flex-grow-1 p-4">{children}</main>
          <Footer />
        </div>
      </div>
    </div>
  );
};
 
export default Layout;
 
 
